import { render } from "./CoBrandThemeLanding.vue?vue&type=template&id=7da912e2&scoped=true"
import script from "./CoBrandThemeLanding.vue?vue&type=script&lang=js"
export * from "./CoBrandThemeLanding.vue?vue&type=script&lang=js"

import "./CoBrandThemeLanding.vue?vue&type=style&index=0&id=7da912e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da912e2"]])

export default __exports__